<lib-link
  textCssClass="flex h-full"
  [link]="link"
  [class]="'border border-[--color-gray-4] sales-box flex justify-center ' + additionalClass"
>
  <div
    class="flex flex-col items-center p-4 md:p-8 justify-center"
    [ngClass]="[brandService.brand, brandService.isChmobile() ? 'fill-[--color-primary]' : 'gradient-icon']"
  >
    @if (icon) {
      <lib-svg class="mb-2 [&_svg]:w-8 [&_svg]:h-8" [svg]="icon" [ngClass]="icon" />
    }
    @if (title) {
      <p class="md:text-lg font-bold text-[--color-text-primary]">{{ title }}</p>
    }
    @if (description) {
      <p class="text-base text-[--color-text-primary] text-center">{{ description }}</p>
    }
  </div>
</lib-link>
